import TableHeader from 'features/ruerupProfiCheck/consultation/models/TableHeader';

const TableHeaders: Array<TableHeader> = [
    {
        title: 'Anbieter (Tarif)',
        comment: '- Anbieter-Name\n- ggfs Tarifbezeichnung\n- Beitragsgarantie in %\n- Zertifizierungs-Nr., sofern hinterlegt'
    },
    {
        title: 'Vertragsart',
        comment: 'FP: Fondspolice\nKP: Kapitalpolice\nKP (Üb. In F.): Kapitalpolice, Überschüsse gehen in Fonds\nIP: Indexpolice\nIP/FP: Mix aus Index- u. Fondspolice\nFSP: Fondssparplan'
    },
    {
        title: 'Garantierte\nRente',
        comment: 'Die garantierte Rente bezieht sich nur auf das Garantiekapital'
    },
    {
        title: 'Garantierter\nRentenfaktor',
        comment: 'Der garantierte Rentenfaktor bezieht sich in der Regel auf das gesamte Verrentungskapital und zwar im Verhältnis je 10.000 €.'
    },
    {
        title: 'Besserungs-\noption',
        comment: 'Besserungsption bedeutet:\nSollte sich zu Rentenbeginn entweder wegen besserer Sterbetafeln (als zu Vertragsbeginn kalkulíert) und/oder aufgrund besserer Marktverzinsung ein höherer Rentenfaktor (RF) und somit eine höhere Rente ergeben, werden die besseren Rechnungsgrundlagen angewendet und der VN wird somit besser gestellt als anfangs garantiert.'
    },
    {
        title: 'Beitragspause\nmit gleichen RG',
        comment: 'Wird der Vertrag nach einer Wiederinkraftsetzung in Folge einer Beitragsreduzierung oder einer Beitragsfreistellung mit den gleichen Garantien und Rechnungsgrundlagen (RG) wie zu Beginn vereinbart fortgesetzt?'
    },
    {
        title: 'Verschiebung\nRentenbeginn',
        comment: 'Eine Verschiebung des Rentenbeginns kann z. B. aus steuerlicher Sicht Sinn machen:\nWenn ein Versicherungsnehmer in die Rente eintritt und über die Riesterrente hinaus jedoch genügend andere Vermögenswerte besitzt (z.B. Auszahlung einer Betriebsrente, Abfindung, Erbschaft etc.) kann er den Rentenbeginn seiner Basisrente auf eigenen Wunsch verschieben.\nDadurch vermeidet er nicht nur die sofortige Besteuerung seiner Basisrente, sondern auch, dass dadurch seine anderen Einkünfte höher besteuert würden.'
    },
    {
        title: 'Hinterbliebenen-\nschutz',
        comment: 'RGZ: max. Rentengarantiezeit (ab 67)\nRKW: Rückkaufswert\nRKA: Restkapitalabfindung (entspricht dem Verrentungskapital abzüglich bereits gezahlter Renten)\nRKA21: Restkapitalabfindung von max. 21 Jahresrenten (Summe von 21 Jahresrenten abzüglich bereits gezahlter Renten)\n\nDie durchschnittliche Rentenbezugsdauer bei gesetzlichen Hinterbliebenenrenten beträgt aktuell 21,5 Jahren. Deshalb sollte die Hinterbliebenenversorung von privaten Rententarifen mindestens 21,5 Jahre oder länger betragen'
    },
    {
        title: 'Effektivkosten in %',
        comment: 'Effektivkosten:\nErrechnet aus den max. möglichen Kosten die während der Ansparphase entstehen können.\n\nWichtig:\nDie Effektivkosten der Rentenversicherer beinhalten bereits die biometrischen Risiken des Langlebigkeitsrisikos!\nDies ist ein ganz entscheidender Punkt, weshalb der direkte Kostenvergleich z. B. zwischen einem Rürup-Fondssparplan und einer Rürup-Rentenversicherung nicht möglich ist!\n\nDie Spalte Effektivkosten ist in der Kundenberatung standardmäßig ausgeblendet, kann jedoch bei Bedarf vom Berater eingeblendet werden.\n\nDer Grund ist, dass wir ganz bewusst die Mehrwerte eines Tarifs durch die Erfüllung der Kundenkriterien in den Vordergrund stellen.'
    },
    {
        title: 'VK in\nRente in %',
        comment: 'VK Rente:\nVerwaltungskosten in der Rentenphase in % von der Jahresrente'
    },
    {
        title: 'Mindest-\nbeitrag in €',
        comment: 'Mindestbeitrag: \nDas ist der Beitrag, den ein Anbieter monatlich mindestens verlangt. \nEs handelt sich in der Regel um den Beitrag für den 37-jährigen Musterkunden mit 30 Jahren Laufzeit. \nBei anderen Laufzeiten können die mtl. Mindestbeiträge teils deutlich abweichen.'
    },
    {
        title: 'Mindest-\nlaufzeit',
        comment: 'Die Mindestlaufzeit gibt an, wie kurz die Laufzeit bei diesem Anbieter sein kann'
    },
    {
        title: 'BU\n',
        comment: 'Absicherung bei Berufsunfähigkeit (BU).\nEntweder Beitragsbefreiung und somit Sparzielgarantie im Falle des\nvorzeitigen Ausscheidens aus dem Berufsleben durch Krankheit und\nUnfall oder eine zusätzliche Leistung in Form einer mtl. BU-Rente'
    },
    {
        title: '4-facher\nSchieberegler',
        comment: ''
    },

    {
        title: 'Exklusiv-\nAnlage',
        comment: ''
    },
    {
        title: 'Physisches\nGold',
        comment: ''
    },

    {
        title: 'Fondsrente\nmöglich?',
        comment: ''
    },

    {
        title: 'Solvency II ohne ÜM?',
        comment: 'Solvency II:\n\nKommt der Versicherer ohne Anwendung der Übergangsmaßnahmen (ÜM) aus? Ja/Nein:\n\nJa:\nDiese Versicherer wenden die Übergangsmaßnahmen nicht an.\n\nNein: \nDiese Versicherer wenden (z. B. wegen nicht ausreichender Rückstellungen für die garantierten Verpflichtungen gegenüber ihren Versicherten) die genehmigungspflichtigen Übergangsmaßnahmen für versicherungtechnische Rückstellungen nach § 352 VAG entweder freiwillig oder zwangsweise an.\n\nEs gibt im Wesentlichen 3 Solvenz-Quoten.\na) Netto bzw. Basis-Quote\nb) Quote mit Volatilitätsanpassung (VA)\nc) Quote mit Übergangsmaßnahmen (ggf. zus. mit VA)\n\na) Die Netto- bzw. Basis-Quote zeigt die Überdeckung über den gesetzlich notwendigen Kapitalanforderungen unter Solvency II ohne Berücksichtigung einer möglichen Volatilitätsanpassung oder von Übergangsmaßnahmen.\n\nDer Umstieg von Solvency I auf Solvency II sah außerdem dauerhafte Anpassungen oder befristete Übergangsregelungen vor:\n\nb) Die Volatilitätsanpassung ist eine dauerhafte Anpassung. Lebensversicherer, mit langfristigen Garantien, können kurzfristige Wertschwankungen der Kapitalanlagen "aussitzen" und müssen Buchverluste nicht realisieren. Mit der Volatilitätsanpassung (VA) werden Unter- oder Überbewertungen von Zinspapieren ausgeglichen.\n\nc) Die Übergangsmaßnahme für versicherungstechnische Rückstellungen ermöglicht den Versicherern eine schrittweise Anwendung der Solvency-II-Vorschriften über einen festen Zeitraum von 16 Jahren bis max 31.12.2031. \n\nb) + c) Die Übergangsmaßnahmen (ÜM) können auch zusammen mit der Volatilitätsanpassung (VA) genutzt werden. Die meisten Lebensversicherer wenden beide Maßnahmen gleichzeitig an. \n\nDie Lebensversicherer der Generali Deutschland wenden die Übergangsmaßnahmen nicht an. Sie haben sich statt dessen nur für die Volatilitätsanpassung enschieden.'
    },

    {
        title: 'Bemerkungen',
        comment: ''
    },

    {
        title: 'Anbieter-\nwechsel',
        comment: 'Hinweis ob ein Wechsel mit Kapitalübertragung zu einem anderen Anbieter möglich ist.'
    },


    {
        title: 'Gültigkeit',
        comment: ''
    }
];
export default TableHeaders;

export const TableHeadersWithoutNewline = JSON.parse(JSON.stringify(TableHeaders)).map((header: TableHeader) => {
    header.title = header.title.replace(/-\n/g, '').replace(/\n/g, ' ');
    return header;
});
